/**
 * Registration for the image service worker. Kept separate from the worker
 * itself so the decision of *whether* to run one lives with the app.
 */

/**
 * Whether a worker may be installed here.
 *
 * Cypress is excluded because a worker answering from Cache Storage bypasses
 * `cy.intercept`, which the image-stubbing specs rely on.
 *
 * @returns {boolean}
 */
const workerAllowed = () => {
  if (!("serviceWorker" in navigator)) return false;
  if (!window.isSecureContext) return false;
  return !window.Cypress;
};

/**
 * Installs the worker that serves stored image derivatives.
 *
 * Registration is deferred to `load` so it never competes with the first paint,
 * and a failure is inert: every consumer checks for a controlling worker before
 * pointing an `<img>` at a path only the worker can answer.
 */
export const registerImageWorker = () => {
  if (!workerAllowed()) return;

  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/sw.js").catch((error) => {
      console.log(
        JSON.stringify({
          severity: "WARNING",
          source: "registerImageWorker",
          event: "registration_failed",
          error: error?.message ?? String(error),
        })
      );
    });
  });
};
